import React, { ReactNode } from 'react';
import { ModalHeaderContainer } from './components/ModalHeaderContainer';
import { ModalHeaderHeading } from './components/ModalHeaderHeading';

type ModalHeaderProps = {
  children: ReactNode;
  className?: string;
};

export const ModalHeader = ({ children, className }: ModalHeaderProps) => {
  return (
    <ModalHeader.Container className={className}>
      <ModalHeader.Heading>{children}</ModalHeader.Heading>
    </ModalHeader.Container>
  );
};

ModalHeader.Container = ModalHeaderContainer;
ModalHeader.Heading = ModalHeaderHeading;
